
import React, { Component } from 'react';
import { Result, Button, Affix, Row, Col, Avatar, Descriptions, message, Input, Tooltip, Card } from 'antd';

import { Link } from 'react-router-dom';

import { WhatsAppOutlined, ArrowLeftOutlined, QuestionCircleOutlined } from '@ant-design/icons';

import { goBack } from '../historyConfig'
import { inject, observer } from 'mobx-react';

import moment from 'moment'

//dinamik yap
/*
moment.locale=require('moment/locale/tr')
*/


import axios from "axios"
import { cdnUrl } from '../config';

import Footer from '../components/Footer'
import Header from '../components/Header'
import { withTranslation } from 'react-i18next';
import TextArea from 'antd/lib/input/TextArea';
import NavbarMenu from '../components/NavbarMenu';
import NavbarPanel from '../components/NavbarPanel';
import { formatMyMoney } from '../helper';

// 
@inject('UserStore')
@observer
class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            avatar: "",
            name: '',
            _id: '',
            displayName: "",
            me: false,
            loading: false,
            editPassword: false
        }
    }

    componentDidMount = () => {
        window.scrollTo(0, 0)
        //  console.log(this.props)

        try {
            //id
            //  const userId = this.props.match.params.id//||"" // getProfile(userId).
            this.props.UserStore.getProfile().then((res) => res.data).then((response) => {
                this.setState({
                    ...response,
                })
                console.log("response", { ...response })
            })

        } catch (error) {
            console.log(error)
        }
    }

    onClickResetPassword = async () => {
        console.log(this.state)
        message.loading()

        try {
            const res = await this.props.UserStore.resetPassword({ oldPassword: this.state.oldPassword, password: this.state.password })
            message.destroy()
            message.success()

        } catch (error) {
            console.log(error.response)
            message.error(_.get(error, "response.data.message", ""))
        }
        finally {
            //   message.destroy()
        }

    }

    onSubmit = async () => {
        const file = this.state.file
        let data = {
            name: this.state.companyName,
            phone: this.state.companyPhone,
            address: this.state.companyAddress,
            visiblePrice: this.state.visiblePrice

        }
        console.log("on submit updateCompany")
        //logo varsa
        if (file) {
            //            logo:this.state.companyLogo,
            let uImage = await this.uploadImage(file)
            console.log({ uImage })
            // const avatarfullpath = _.get(uImage,"data.fullpath")
            //v1 (güncellendi)
            const avatarfullpath = `${cdnUrl}/uploads/images/companylogo/${_.get(uImage, "data.name", "default.png")}`
            data.logo = avatarfullpath
            const serverData = await this.props.UserStore.updateCompany(data);
            console.log(serverData)
            this.setState({ editCompany: false })
        }
        //logo yoksa
        else {
            try {
                //setPriceVisible
                const serverData = await this.props.UserStore.updateCompany(data);
                console.log(serverData)
                this.setState({ editCompany: false })

            } catch (error) {
                console.log(error)
            }
        }
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    onClickVisiblePrice = async () => {
        const newVisible = !this.state.visiblePrice
        this.setState({ visiblePrice: newVisible })
        try {
            //setPriceVisible
            const serverData = await this.props.UserStore.setPriceVisible(newVisible);
            console.log(serverData)

        } catch (error) {
            console.log(error)
        }
    }

    uploadImage = (file) => {
        // let file = this.state.file
        let formData = new FormData()

        formData.append("image", file)
        formData.append("ornek", "örnek form içeriği")
        const url = `${cdnUrl}/upload/company-logo`
        const headers = {
            'content-type': 'multipart/form-data',
            token: "token",
            authorization: "tokencontent",
            admin: "ferdiozer",
            username: _.get(this.state, "user.username")
        }
        return axios.post(url, formData, { headers: headers })
    }


    onChangeImage = (e) => {
        let file = e.target.files[0]
        this.setState({
            file: file
        })
        this.getBase64(file, (img) => {
            this.setState({
                companyLogo: img
            })
        })
    }

    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    render() {
        const { t } = this.props
        const { user } = this.props.UserStore

        const activeUserType = _.get(user, "userType", 4)

        return (
            <div>
                <NavbarPanel page="profile" />
                <Card title={"Profil"}>
                    <Descriptions title={t('generalInfo')}>
                        {
                            //  <Descriptions.Item label={t('name')} >{_.get(user, "name")}</Descriptions.Item>
                            //  <Descriptions.Item label={t('email')}>{_.get(user, "email")}</Descriptions.Item>
                        }
                        <Descriptions.Item label={t('username')}>{_.get(user, "username")}</Descriptions.Item>

                        {
                            activeUserType === 2
                            &&
                            <Descriptions.Item label="Kredi">{_.get(user, "credit")}</Descriptions.Item>
                        }

                        {
                            activeUserType === 4
                            &&
                            <Descriptions.Item label="Bakiye">{formatMyMoney(_.get(user, "balance"))} ₺</Descriptions.Item>
                        }
                        {
                            activeUserType === 3
                            &&
                            <>
                                <Descriptions.Item label="Kredi">{_.get(user, "credit")}</Descriptions.Item>
                                <Descriptions.Item label="Bakiye">{formatMyMoney(_.get(user, "balance"))} ₺</Descriptions.Item>
                            </>
                        }

                        <Descriptions.Item label={t('createdDate')}>{new Date(_.get(user, "created")).toLocaleString()}</Descriptions.Item>
                        <Descriptions.Item>
                            <Button onClick={() => this.setState({ editPassword: !this.state.editPassword })}>
                                Şifre İşlemleri
                            </Button>
                        </Descriptions.Item>
                    </Descriptions>

                    {
                        this.state.editPassword
                        &&



                        <Descriptions.Item>
                            <span>
                                <Row>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={12}>
                                                <Input onChange={(e) => this.onChange(e)} name="oldPassword" width="120px" placeholder="Eski Şifreniz" />
                                            </Col>
                                            <Col span={12}> <Input onChange={(e) => this.onChange(e)} name="password" placeholder="Yeni Şifreniz" /></Col>
                                        </Row>
                                        <Row>
                                            <Col style={{ marginTop: 10 }} span={24}><Button block type="primary"
                                                onClick={() => this.onClickResetPassword()}>
                                                {t('resetPassword')}
                                            </Button></Col>
                                        </Row>
                                    </Col>
                                </Row>

                            </span>

                        </Descriptions.Item>

                    }

                </Card>

            </div>
        )
    }
}

export default withTranslation()(Profile)